import { useVertical } from 'lib/Hooks/useVertical';

/** @typedef {import('lib/types/verticalContext.js').VerticalContextValue | "default"} Brand */

/**
 * @typedef {Partial<Record<Brand, string>> & { default: string }} TextAlternatives
 */

/**
 * Branded text alternatives for different verticals.
 *
 * Additional keys can be added for each piece of branded text as needed.  The value
 * should be an object with keys for each vertical that needs specific text and a
 * `default` key for everything else.
 *
 * @satisfies {Record<string, TextAlternatives>}
 */
const BRAND_TEXT = {
  createAccountHeader: {
    today: 'Create Your Free TODAY Account',
    default: 'Create Account',
  },
};

/**
 * Get branded text based on the current vertical.
 *
 * @param {keyof typeof BRAND_TEXT} key The key to retrieve from the BRAND_TEXT object.
 * @returns {string} An object containing branded text.
 */
export function useBrandText(key) {
  const { vertical } = useVertical();

  /** @type {TextAlternatives} */
  const alternatives = BRAND_TEXT[key];

  return alternatives[vertical] ?? alternatives.default;
}

/**
 * Get branded text based on the current vertical.
 *
 * @param {keyof typeof BRAND_TEXT} key The key to retrieve from the BRAND_TEXT object.
 */
export function BrandText(key) {
  return useBrandText(key);
}
